import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { isNil } from 'ramda';

import { paymentsRestHooks } from '../../../../../../store/Memberships/PaymentsSlice';
import { paymentRestHooks } from '../../../../../../store/Memberships/PaymentSlice';
import PaymentPresenter from '../../../../../../presenters/Membership/PaymentPresenter';
import { useFetchStatus } from '../../../../../../utils/fetchStatusUtils';
import ListSkeleton from '../../../../../../components/Skeletons/ListSkeleton';
import {
  LIST_SKELETON_HEIGHT,
  LIST_SKELETON_WIDTH,
} from '../../../../../../pages/constants';
import { Dialog } from '../../../../../../components';

import PaymentsTable from './components/PaymentsTable';

const Payments = (props) => {
  const { membershipId, onResponseUpdate } = props;
  const {
    loadPayments,
    loadResetPayments,
    payments: { loadingStatus, items },
  } = paymentsRestHooks.use();

  const {
    createPayment,
    deletePayment,
    payment: { errors },
  } = paymentRestHooks.use();

  const { isFulfilled } = useFetchStatus(loadingStatus);

  const [deletedPayment, setDeletedPayment] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const paymentType = PaymentPresenter.typeReadable(deletedPayment);
  const paymentAmount = PaymentPresenter.amountReadable(deletedPayment);
  const warningText = `Are you sure you want to remove ${paymentType} payment with ${paymentAmount} amount?`;
  const handleDialogOpen = (payment) => () => {
    setDeletedPayment(payment);
    setIsDialogOpen(true);
  };

  const handleDialogClose = () => setIsDialogOpen(false);

  const handleDeleteConfirm = async () => {
    const membershipId = PaymentPresenter.membershipId(deletedPayment);
    const paymentId = PaymentPresenter.id(deletedPayment);
    await deletePayment(membershipId, paymentId);

    handleDialogClose();
    loadPayments(membershipId);
  };

  const handlePaymentCreate = async (...params) => {
    await createPayment(...params);

    loadPayments(membershipId);
  };

  useEffect(() => {
    loadPayments(membershipId);
    return () => {
      loadResetPayments();
    };
  }, []);

  useEffect(() => {
    if (!isNil(errors)) {
      onResponseUpdate({ body: errors });
    }
    return () => {
      onResponseUpdate({});
    };
  }, [errors]);

  if (!isFulfilled) {
    return (
      <ListSkeleton height={LIST_SKELETON_HEIGHT} width={LIST_SKELETON_WIDTH} />
    );
  }

  return (
    <div>
      <Dialog
        className="deletion"
        isOpen={isDialogOpen}
        message={warningText}
        onConfirm={handleDeleteConfirm}
        onCancel={handleDialogClose}
      />
      <PaymentsTable
        payments={items}
        membershipId={membershipId}
        onDialogOpen={handleDialogOpen}
        onPaymentCreate={handlePaymentCreate}
      />
    </div>
  );
};

export default Payments;

Payments.propTypes = {
  membershipId: PropTypes.string.isRequired,
  onResponseUpdate: PropTypes.func.isRequired,
};
